<template>
  <CardHeaderTips
    v-if="isShowCardHead"
    :main-text="cardHeaderTips.mainText"
    :normal-text="cardHeaderTips.normalText"
    style="margin-left: -12px"
  />
  <div
    class="error-card"
    :class="{ special: isChatAssistant }"
    :style="{ width: !isMobile() && '400px' }"
  >
    <div class="error-card__title">
      <i class="icon-error-warning-fill t-iconfont"></i>
      {{ title }}
    </div>
    <template v-if="isContentEmpty">
      <div class="error-card__content">
        <span class="error-card__content-text" v-html="emptyTips"></span>
      </div>
    </template>
    <template v-else>
      <div class="error-card__content">
        <span class="error-card__content-text" v-html="tips"></span>
        <a
          v-if="isChatAssistant && !isBalanceSufficient"
          class="error-card__content-text error-card__operate"
          :class="{ 'is-disabled': !canRetry }"
          :disabled="!canRetry"
          @click="canRetry ? handleRetry() : null"
          >重新提炼</a
        >
      </div>
    </template>
  </div>
</template>

<script setup>
import { ref, onMounted, computed } from 'vue'
import CardHeaderTips from '@/components/Cards/components/card-header-tips.vue'
import { isMobile } from '@/utils/index'

const emit = defineEmits(['retry'])
const props = defineProps({
  attributes: {
    type: Object
  }
})

// 重试按钮是否可点击
const canRetry = ref(false)
// 是否内容为空
const isContentEmpty = ref(false)

// 计算属性-是否跟进助手 ？？ 后端这里返回1，这里判断的是2
const isChatAssistant = computed(() => {
  return Number(props.attributes?.assistantId) === 2
})

// 是否余额不足
const isBalanceSufficient = computed(() => {
  return props.attributes?.chatInfo === '550034'
})

// 计算属性-操作过程提示语
const tipText = computed(() => {
  // 操作过程提示语映射（0-通用情景，1-医药行业情景）
  const processingStatusMap = {
    0: '入库',
    1: '分析'
  }
  const { isMedicalIndustry = 0, warehouseType = 0 } = props.attributes || {}
  // 当warehouseType为0时返回'分析'，否则根据isMedicalIndustry决定
  const statusKey = Number(warehouseType) === 0 ? 1 : Number(isMedicalIndustry)

  return processingStatusMap[statusKey] || processingStatusMap[0]
})

// 计算属性-卡片内标题
const title = computed(() => {
  if (isChatAssistant.value) {
    return '提炼失败'
  }
  const _chatInfo = props.attributes?.chatInfo
  return _chatInfo?.errorMsgInnerTitle || _chatInfo?.errorMsgTitle || ''
})

// 计算属性-提示语
const tips = computed(() => {
  if (isBalanceSufficient.value) {
    return '当前组织AI用量额度已耗尽，请联系管理员处理'
  }
  if (isChatAssistant.value) {
    return '同时间太多人使用，大模型有些波动，请'
  }
  return props.attributes?.chatInfo?.errorMsg || ''
})

const emptyTips = computed(() => {
  return '当前音频转写内容为空，请确认是否上传正确文件。'
})

// 计算属性-是否展示卡片头提示语
const isShowCardHead = computed(() => !!props.attributes?.chatInfo?.errorMsgTitle)

// 计算属性-卡片头提示语
const cardHeaderTips = computed(() => {
  if (isChatAssistant.value) {
    return {
      mainText: `正在${tipText.value}中`,
      normalText: '，预计 2~3 分钟，无需在此等待'
    }
  }
  return {
    mainText: '',
    normalText: props.attributes?.chatInfo?.errorMsgTitle || ''
  }
})

/**
 * 重新提炼
 */
const handleRetry = () => {
  canRetry.value = false
  emit('retry', props.attributes?.id)
}
/**
 * 初始化
 */
const init = () => {
  if (isChatAssistant.value && +props.attributes?.retryAllowed === 1) {
    canRetry.value = true
  } else if (isChatAssistant.value && +props.attributes?.retryAllowed === 2) {
    isContentEmpty.value = true // 错误类型 内容为空
  }
}

onMounted(() => {
  init()
})
</script>

<style lang="less" scoped>
.special {
  border-radius: 8px;
  background: #fff;
  padding: 12px;
  margin: -12px;
}
.error-card {
  font-size: 14px;
  background-color: #fff;
  padding: 16px;
  border-radius: 8px;
  box-sizing: border-box;
  &__title {
    color: #969799;
    height: 20px;
    line-height: 20px;
    margin-bottom: 16px;
    .icon-error-warning-fill {
      width: 20px;
      height: 20px;
      margin-right: 4px;
    }
  }
  &__content {
    color: #323233;

    &-text {
      font-family: PingFang SC;
      font-size: 14px;
      font-weight: normal;
      line-height: normal;
      letter-spacing: 0em;
      color: #323233;
    }

    .el-button.is-text:not(.is-disabled):hover {
      background: transparent !important;
    }
    .el-button,
    .el-button.is-round {
      padding: 0 !important;
    }
  }

  &__operate {
    color: #248df5;
    cursor: pointer;

    &.is-disabled {
      color: #c8c9cc;
      cursor: not-allowed;
      pointer-events: none;
    }
  }
}
</style>
